import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "searchResultContainer__header" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "client-city" }
const _hoisted_4 = {
  key: 0,
  class: "client-list"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 0,
  class: "client-list__item-divider"
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = {
  key: 0,
  class: "client-list__item-divider"
}
const _hoisted_9 = {
  key: 1,
  class: "client-inn"
}
const _hoisted_10 = { class: "client-inn__title" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "searchResultContainer__footer" }
const _hoisted_13 = { class: "client-tags" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { class: "client-date" }

import {
	computed,
	ref
} from "vue";
import {SearchClient} from "@/ api/SearchApi";
import {useRoute} from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'ClientCard',
  props: {
    client: {},
    textFilter: {}
  },
  setup(__props: any) {

const props = __props;

const isExpanded = ref(false)
const route = useRoute()

const isOpened = computed(() =>
	route.query.page === 'client' && Number(route.query.id) === props.client.Id
)

function formatDate(date?: string | Date) {
	if (!date) return "";

	const dateObj = typeof date === "string" ? new Date(date) : date;
	return dateObj.toLocaleDateString("ru-RU", {
		day: "2-digit",
		month: "2-digit",
		year: "2-digit",
	});
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
		'searchResultContainer': true,
		'searchResultContainer--opened': isOpened.value
	})
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: {
					query: {
						page: 'client',
						id: props.client.Id,
					}
				},
        class: "client-link"
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", {
            innerHTML: _ctx.client.Name
          }, null, 8, _hoisted_2)
        ]),
        _: 1
      }, 8, ["to"]),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.client.AddressChain?.[0]), 1)
    ]),
    (_ctx.client.Clients)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.client.Clients.slice(0, 2), (c, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: c.Id
            }, [
              _createVNode(_component_router_link, {
                to: {
					query: {
						page: 'client',
						id: c.Id,
					}
				},
                class: "client-list__item"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    innerHTML: c.Name
                  }, null, 8, _hoisted_5)
                ]),
                _: 2
              }, 1032, ["to"]),
              (index === 0 ? _ctx.client.Clients.length > 1 : isExpanded.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, " / "))
                : _createCommentVNode("", true)
            ], 64))
          }), 128)),
          (!isExpanded.value && _ctx.client.Clients.length > 2)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "client-list__show-more",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (isExpanded.value = !isExpanded.value))
              }, " еще " + _toDisplayString(_ctx.client.Clients.length - 2), 1))
            : _createCommentVNode("", true),
          (isExpanded.value)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.client.Clients.slice(2, _ctx.client.Clients.length), (c, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                  _createVNode(_component_router_link, {
                    to: {
							query: {
								page: 'client',
								id: c.Id,
							}
						},
                    class: "client-list__item"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        innerHTML: c.Name
                      }, null, 8, _hoisted_7)
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  (index + 1 < _ctx.client.Clients.slice(2, _ctx.client.Clients.length).length)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, " / "))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.client.Parameters?.length === 1 ? !!_ctx.client.Parameters[0].Instance?.Value : !!_ctx.client.Parameters?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.client.Parameters, (param, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              (param.Instance && param.Instance.Value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("span", _hoisted_10, _toDisplayString(param.Instance.Key) + ": ", 1),
                    _createElementVNode("span", {
                      innerHTML: param.Instance.Value
                    }, null, 8, _hoisted_11)
                  ], 64))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.client.Tags, (tag) => {
          return (_openBlock(), _createElementBlock("div", {
            key: tag.Id,
            class: "client-tag"
          }, [
            _cache[1] || (_cache[1] = _createTextVNode(" # ")),
            _createElementVNode("span", {
              innerHTML: tag.Name.toLowerCase()
            }, null, 8, _hoisted_14)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_15, _toDisplayString(formatDate(_ctx.client.CreateTime)), 1)
    ])
  ], 2))
}
}

})